<template>
    <div>
        <Tippy
            trigger="mouseenter click"
            animation="scale"
            placement="auto"
        >
            <div class="text-muval-gray-2 cursor-pointer rounded-full">
                <SvgIcon
                    name="system-information"
                    class="size-5"
                />
            </div>
            <template #content>
                <div class="rounded-muval-2 shadow-muval-2 relative max-w-sm bg-white px-2 py-1 text-sm">
                    <slot name="custom">
                        <p class="font-body text-sm font-normal">{{ text }}</p>
                    </slot>
                </div>
            </template>
        </Tippy>
    </div>
</template>

<script setup>
defineProps({
    text: {
        type: String,
        default: '',
    },
});
</script>
